export class OrmDeclineQuoteRequestModel {
  constructor() {
    this.quoteId = ''
    this.declineReason = ''
    this.vehicleLocation = ''
    this.vehicleSuburb = ''
  }
}
